import { render, staticRenderFns } from "./Content2.vue?vue&type=template&id=5c965ff4&scoped=true&"
import script from "./Content2.vue?vue&type=script&lang=js&"
export * from "./Content2.vue?vue&type=script&lang=js&"
import style0 from "./Content2.vue?vue&type=style&index=0&id=5c965ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c965ff4",
  null
  
)

export default component.exports